<div class="input-wrapper">
  <label class="label" [class.error]="error">
    <div class="d-flex align-items-end">
      <span>{{ label }}</span>
      @if (required) {
        <span class="required">*</span>
      }
    </div>
    @if (trialing) {
      <div class="d-flex align-items-end">
        <span class="trialing">{{ trialing }}</span>
      </div>
    }
  </label>
  <ng-content></ng-content>
</div>
